import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { XCircleIcon } from 'lucide-react';
export function WhyFailedSection() {
  const ref = useScrollReveal();
  return <section ref={ref} className="w-full section-padding" style={{
    backgroundColor: '#faf7f2'
  }} aria-label="Why previous methods failed" data-id="element-344">
      <div className="max-w-3xl mx-auto" data-id="element-345">
        {/* Label */}
        <div className="scroll-reveal text-center mb-10" data-id="element-346">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase px-3 py-1.5 rounded-full" style={{
          color: '#c9a96e',
          backgroundColor: 'rgba(201,169,110,0.12)',
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-347">
            Why Nothing Has Worked
          </span>
        </div>

        {/* Heading */}
        <div className="scroll-reveal scroll-reveal-delay-1 text-center mb-4" data-id="element-348">
          <h2 className="text-3xl md:text-4xl font-bold leading-tight" style={{
          fontFamily: "'Playfair Display', serif",
          color: '#1a2744'
        }} data-id="element-349">
            The Advice You've Been Given Was Built for{' '}
            <span className="italic" data-id="element-350">Infants.</span>
          </h2>
        </div>

        <div className="scroll-reveal scroll-reveal-delay-2 gold-divider mb-12" data-id="element-351" />

        {/* Reasons */}
        <div className="space-y-6" data-id="element-352">
          <div className="scroll-reveal scroll-reveal-delay-2 flex gap-4 items-start" data-id="element-353">
            <div className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center mt-0.5" style={{
            backgroundColor: 'rgba(201,169,110,0.12)'
          }} data-id="element-354">
              <XCircleIcon className="w-5 h-5" style={{
              color: '#c9a96e'
            }} aria-hidden="true" data-id="element-355" />
            </div>
            <div data-id="element-356">
              <h3 className="text-lg font-bold mb-1" style={{
              fontFamily: "'Playfair Display', serif",
              color: '#1a2744'
            }} data-id="element-357">
                Infant sleep training fails with toddlers.
              </h3>
              <p className="text-base leading-relaxed" style={{
              color: '#6b6560',
              fontFamily: "'Inter', sans-serif"
            }} data-id="element-358">
                Toddlers have developed willpower that 4-month-olds simply don't
                have. The same techniques don't apply.
              </p>
            </div>
          </div>

          <div className="scroll-reveal scroll-reveal-delay-3 flex gap-4 items-start" data-id="element-359">
            <div className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center mt-0.5" style={{
            backgroundColor: 'rgba(201,169,110,0.12)'
          }} data-id="element-360">
              <XCircleIcon className="w-5 h-5" style={{
              color: '#c9a96e'
            }} aria-hidden="true" data-id="element-361" />
            </div>
            <div data-id="element-362">
              <h3 className="text-lg font-bold mb-1" style={{
              fontFamily: "'Playfair Display', serif",
              color: '#1a2744'
            }} data-id="element-363">
                "Wearing them out" backfires.
              </h3>
              <p className="text-base leading-relaxed" style={{
              color: '#6b6560',
              fontFamily: "'Inter', sans-serif"
            }} data-id="element-364">
                A big day at the park actually creates a cortisol spike, making
                it chemically impossible for them to fall into deep sleep.
              </p>
            </div>
          </div>

          <div className="scroll-reveal scroll-reveal-delay-4 flex gap-4 items-start" data-id="element-365">
            <div className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center mt-0.5" style={{
            backgroundColor: 'rgba(201,169,110,0.12)'
          }} data-id="element-366">
              <XCircleIcon className="w-5 h-5" style={{
              color: '#c9a96e'
            }} aria-hidden="true" data-id="element-367" />
            </div>
            <div data-id="element-368">
              <h3 className="text-lg font-bold mb-1" style={{
              fontFamily: "'Playfair Display', serif",
              color: '#1a2744'
            }} data-id="element-369">
                Inconsistency creates a "gambler's mentality."
              </h3>
              <p className="text-base leading-relaxed" style={{
              color: '#6b6560',
              fontFamily: "'Inter', sans-serif"
            }} data-id="element-370">
                They will scream longer tonight because they know you gave in
                last night. Intermittent rewards are the most powerful
                reinforcers in existence.
              </p>
            </div>
          </div>

          <div className="scroll-reveal scroll-reveal-delay-5 flex gap-4 items-start" data-id="element-371">
            <div className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center mt-0.5" style={{
            backgroundColor: 'rgba(201,169,110,0.12)'
          }} data-id="element-372">
              <XCircleIcon className="w-5 h-5" style={{
              color: '#c9a96e'
            }} aria-hidden="true" data-id="element-373" />
            </div>
            <div data-id="element-374">
              <h3 className="text-lg font-bold mb-1" style={{
              fontFamily: "'Playfair Display', serif",
              color: '#1a2744'
            }} data-id="element-375">
                Night lights and 2 AM rituals kill melatonin.
              </h3>
              <p className="text-base leading-relaxed" style={{
              color: '#6b6560',
              fontFamily: "'Inter', sans-serif"
            }} data-id="element-376">
                "Social" interactions at 2 AM trigger the brain's alertness
                centers, shutting off melatonin production instantly.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}